import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import LoadDetail from '../../LoadDetail'
import { getTextCapitalized } from '../../../../../tools/dataParse'
import styles from './styles'

const StopLocation = (props) => {
  const { prefix, stop } = props
  return (
    <View style={styles.container}>
      <LoadDetail
        title={`${prefix} Location`}
        text={stop?.location ? getTextCapitalized(stop.location) : '- -'}
      />
      <LoadDetail
        title={`${prefix} Address`}
        text={stop?.address ? getTextCapitalized(stop.address) : '- -'}
      />
    </View>
  )
}

StopLocation.propTypes = {
  stop: PropTypes.object,
  prefix: PropTypes.string
}

export default StopLocation
